import {
  _await,
  ExtendedModel,
  fromSnapshot,
  idProp,
  model,
  Model,
  modelFlow,
  prop,
  tProp,
  types,
} from 'mobx-keystone';
import { MainModel } from 'store/utils/base-model';
import { FollowedTraderDto } from '../../../../../../packages/models/dist';

@model('trader-position')
export class Position extends Model({
  symbol: prop<string>(),
  entryPrice: prop<number>(),
  markPrice: prop<number>(),
  pnl: prop<number>(),
  roe: prop<number>(),
  amount: prop<number>(),
  updateTimeStamp: prop<number>(),
  tradeBefore: prop<boolean>(),
  long: prop<boolean>(),
  short: prop<boolean>(),
  leverage: prop<number>(),
}) {
  get formattedValue() {
    return `${(this.markPrice * this.amount).toFixed(2)} USDT`;
  }
}

@model('followed-trader')
export class FollowedTrader extends ExtendedModel(MainModel, {
  id: idProp,
  name: prop<string>(),
  encryptedUid: prop<string>(),
  positions: tProp(types.array(types.model(Position)), () => []),
}) {
  @modelFlow
  *fetchPositions() {
    const positions = yield* _await(this.api.fetch(`binance-leaderboard/fetch-positions/${this.encryptedUid}`));
    this.positions = fromSnapshot(positions);
  }

  @modelFlow
  *remove() {
    yield* _await(this.api.delete(`binance-leaderboard/followed-trader/${this.id}`));
    this.isDeleted = true;
  }
}

@model('leaderboard')
export class Leaderboard extends ExtendedModel(MainModel, {
  followedTraders: tProp(types.array(types.model(FollowedTrader)), () => []),
  isInitiallyFetched: tProp(types.boolean, false),
}) {
  @modelFlow
  *fetchTraders() {
    const followedTraders = yield* _await(this.api.fetch('binance-leaderboard/followed-traders'));
    this.followedTraders = fromSnapshot(followedTraders);
    this.isInitiallyFetched = true;
  }

  @modelFlow
  *addFollowedTrader(body: FollowedTraderDto) {
    const followedTrader = yield* _await(this.api.create('binance-leaderboard/followed-trader', body));
    this.followedTraders.push(fromSnapshot(followedTrader));
  }

  async fetchSelectedFollowersPositions(selectedId?: string) {
    await this.fetchTraders();
    return await this.followedTraders.find(({ id }) => id === selectedId)?.fetchPositions();
  }

  getSelectedFollowersPositions(selectedId?: string) {
    return this.followedTraders.find(({ id }) => id === selectedId)?.positions ?? [];
  }
}
